<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" md="10" lg="8">
        <v-card class="elevation-12">
          <v-toolbar color="green darken-2" dark flat>用户信息</v-toolbar>
          <v-card-text>
            <user-form model="myInfo" :userData="userData" @submit="submit"></user-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import userForm from "@/components/userForm";
export default {
  components: {
    userForm,
  },
  data: function () {
    return {
      userData: this.$store.state.userInfo,
    };
  },
  methods: {
    submit(data) {
      this.$api.editMyInfo(data).then(res => {
        this.$store.commit("setuserInfo", data);
        this.$router.go(-1)
      }).catch(error=>{
        console.error(error);
        this.$store.commit('setsnack',{message:'更新用户信息失败！'})
      })
    },
  },
};
</script>